import { memo } from 'react';
import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { Button } from '~/components/isolated/Button';
import styles from './OtpFooter.module.scss';

/**
 * Props for the OtpFooter component.
 */
interface OtpFooterProps {
  /** Callback to go back and change phone number */
  onChangeNumber: () => void;
  /** Callback to submit OTP verification */
  onSubmit: () => void;
  /** Text for the change number button */
  changeNumberText: string;
  /** Text for the submit button */
  submitText: string;
  /** Whether the submit button should be disabled */
  isSubmitDisabled?: boolean;
  /** Whether to show loading state on submit button */
  isLoading?: boolean;
}

/**
 * Footer component for OTP view with navigation and submit buttons.
 */
const OtpFooter = memo(
  ({
    onChangeNumber,
    onSubmit,
    changeNumberText,
    submitText,
    isSubmitDisabled = false,
    isLoading = false,
  }: OtpFooterProps) => {
    return (
      <div className={styles.root}>
        <Button
          variant="secondary"
          size="XL"
          onClick={onChangeNumber}
          className={styles.changeButton}
          startIcon={
            <Icon type="arrow" size={24} className="icon__rotate-180" />
          }
        >
          {changeNumberText}
        </Button>

        <Button
          variant={company.match({
            mcosmetic: 'brand',
            default: 'primary',
          })}
          size="XL"
          onClick={onSubmit}
          disabled={isSubmitDisabled}
          isLoading={isLoading}
          className={styles.submitButton}
        >
          {submitText}
        </Button>
      </div>
    );
  },
);

OtpFooter.displayName = 'OtpFooter';

export default OtpFooter;
